import React, { useState, useRef } from "react";
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import ImageIcon from '@mui/icons-material/Image';
import { Button, Grid, IconButton, TextField, Tooltip, MenuItem } from "@mui/material";
import Box from "@mui/material/Box";
import Divider from '@mui/material/Divider';
import { useDispatch, useSelector } from "react-redux";
import { addMajSpider } from "../../store/siteWebSlice";
import { SITEWEB_SERVER_BASE_URL, apiClient } from "../../util/apiClient";
import { convertToBase64, errorNotify, successNotify } from "../../util/functions";
import PostDialog from "../components/PostDialog";
import { IFonctionnaliteListe, IMajSpiderState, ITypeMaj } from "./interface";
import axios from "axios";
import { IReduxState } from "../../store";


interface IAddProps {
  majSpiderState: IMajSpiderState;
  setMajSpiderState: (x: IMajSpiderState) => void;
  selectedFile: any;
  setSelectedFile: (x: any) => void;
  fonctionnaliteListe: IFonctionnaliteListe[];
  setFonctionnaliteListe: (x: IFonctionnaliteListe[]) => void;
}



const Add = (props: IAddProps) => {

  //props
  const {
    majSpiderState,
    setMajSpiderState,
    selectedFile,
    setSelectedFile,
    fonctionnaliteListe,
    setFonctionnaliteListe
  } = props
    console.log("🚀 ~ Add ~ majSpiderState:", majSpiderState)

  //redux
  const { allSpiderApp } = useSelector((state: IReduxState) => state.siteWeb);
  console.log("🚀 ~ Add ~ allSpiderApp:", allSpiderApp)

  //hooks
  const selectPhoto: any = useRef(null);
  const selectGaleriePhoto: any = useRef(null);




  //fonctions
  const handleInputChange = (e: any) => {
    const { value, name } = e.target
    setMajSpiderState({ ...majSpiderState, [name]: value })
  }


  /////////////////////////// fonctionnalité //////////////////////
  //ajoute un champ de saisie 
  const handleAddRowFonctionnalite = () => {
    const newData = [...fonctionnaliteListe]
    setFonctionnaliteListe([...newData, { fonctionnalite: "" }])
  }

  //supprimer un champ de saisie 
  const handleFonctionnaliteRowDelete = (currentIndex: number) => {
    let newData = [...fonctionnaliteListe]
    const res = newData.filter((item, index) => index !== currentIndex)
    setFonctionnaliteListe(res)
  };

  //ecrire dans un champ de saisie 
  const handleFonctionnaliteInputChange = (event: any, index: number) => {
    const { name, value } = event.target;
    const updatedFonctionnaliteListeListe: any = [...fonctionnaliteListe];
    updatedFonctionnaliteListeListe[index][name] = value;
    setFonctionnaliteListe(updatedFonctionnaliteListeListe);
  };



  return (
    <Box sx={{ flexGrow: 1, width: "100%" }}>
      <Grid
        container
        spacing={2}
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
      >
        <Grid item md={6} xs={12} sm={6}>
          <TextField
            fullWidth
            select
            size="small"
            name="idApp"
            label="Application *"
            value={majSpiderState.idApp}
            onChange={handleInputChange}
          >
            {allSpiderApp.map((option) => (
              <MenuItem key={option.idApp} value={option.idApp}>
                {option.libApp}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid item md={12} xs={12} sm={12}>
          <TextField
            // fullWidth
            style={{ width: "50%" }}
            size="small"
            name="versionNumber"
            label="version *"
            value={majSpiderState.versionNumber}
            onChange={handleInputChange}
          />
        </Grid>

        <Grid item md={12} xs={12} sm={12}>
          <TextField
            // fullWidth
            style={{ width: "50%" }}
            size="small"
            type="date"
            name="versionDate"
            helperText="Date de la version"
            value={majSpiderState.versionDate}
            onChange={handleInputChange}
          />
        </Grid>

        <Grid item md={6} xs={12} sm={6}>
          <Grid
            container
            spacing={2}
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
          >

            <Grid item md={12} xs={12} sm={12}>
              {selectedFile?.name}
            </Grid>

            <Grid item md={12} xs={12} sm={12}>
              <Tooltip title=" Charger le fichier">
                <Button
                  variant="outlined"
                  color="primary"
                  component="label"
                  startIcon={<ImageIcon />}
                  style={{ marginTop: 10 }}
                  onClick={() => {
                    selectPhoto?.current?.click();
                  }}
                >
                  Charger le fichier exe
                </Button>
              </Tooltip>
              <input
                hidden
                multiple
                type="file"
                name="file"
                ref={selectPhoto}
                onChange={(e: any) => {
                  const file = e.target.files[0];
                  if (file) {
                    // const img = URL.createObjectURL(file);
                    // setImage(img);
                    setSelectedFile(e.target.files[0]);
                  }
                }}
              />
            </Grid>

            <Grid item md={12} xs={12} sm={12}>
              <Divider />
            </Grid>

            <Grid item md={12} xs={12} sm={12}>
              <Grid
                container
                spacing={2}
                direction="row"
                justifyContent="flex-start"
                alignItems="center"
              >

                {fonctionnaliteListe.map((item: any, index: number) => (
                  <Grid key={index} item md={12} xs={12} sm={12} >
                    <TextField
                      // fullWidth
                      style={{ width: "90%" }}
                      size="small"
                      name="fonctionnalite"
                      label={"Fonctionnalite" + (index + 1)}
                      value={item.fonctionnalite}
                      onChange={(e: any) => handleFonctionnaliteInputChange(e, index)}
                    />
                    <Tooltip title="Supprimer">
                      <IconButton
                        onClick={() => handleFonctionnaliteRowDelete(index)}
                        style={{ marginTop: 10 }}
                      >
                        <DeleteIcon color="error" />
                      </IconButton>
                    </Tooltip>
                  </Grid>
                ))}

                <Grid item md={12} xs={12} sm={12}>
                  <Tooltip title="Ajouter une fonctionnalité">
                    <Button
                      onClick={handleAddRowFonctionnalite}
                      startIcon={<AddIcon color="primary" />}
                    >
                      Ajouter une nouvelle fonctionnalité apportée
                    </Button>
                  </Tooltip>
                </Grid>
              </Grid>
            </Grid>

          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

const initialState = {
  versionNumber: "",
  versionDate: "",
  idTypeMaj: null
}

const DialogAdd = () => {



  //redux
  const dispatch = useDispatch();
  const { majSpiders } = useSelector((state: IReduxState) => state.siteWeb);

  //hooks
  const [open, setOpen] = useState<boolean>(false)
  const [addLoading, setAddLoading] = useState<boolean>(false)
  const [majSpiderState, setMajSpiderState] = useState<any>(initialState)
  const [fonctionnaliteListe, setFonctionnaliteListe] = useState<IFonctionnaliteListe[]>([{ fonctionnalite: "" }])
  const [selectedFile, setSelectedFile] = useState<any>({})

  //Fermer la boite dee dialog d'ajout
  const onClose = () => {
    setOpen(false)
  }

  //Ouvrir la boite de dialog d'ajout
  const handleOpenDialog = () => {
    setOpen(true)
  }

  //Ajouter une mise à jour

  const handleMajSpiderSave = async (e: any) => {
    e.preventDefault();
  
    // Activer le chargement
    setAddLoading(true);
  
    try {
      // Vérification des champs requis
      const { versionNumber, versionDate, idApp } = majSpiderState;
  
      if (!versionNumber || !versionDate || !idApp) {
        errorNotify("Veuillez remplir tous les champs obligatoires");
        setAddLoading(false);
        return;
      }
  
      if (!selectedFile?.name) {
        errorNotify("Aucun fichier sélectionné");
        setAddLoading(false);
        return;
      }
  
      // Construction de la liste des fonctionnalités
      const VersionDescriptionArray: string[] = fonctionnaliteListe.map(item => item.fonctionnalite);
  
      // Création de l'objet de base
      const newObjectToPost = {
        ...majSpiderState,
        idSpiderVersion: majSpiders[0].idSpiderVersion
      };
      console.log("🚀 ~ handleMajSpiderSave ~ newObjectToPost:", newObjectToPost)
  
      // Construction du formData
      const formData = new FormData();
      console.log("🚀 ~ handleMajSpiderSave ~ formData++++++++++++++++++++++++:", formData)
  
      Object.entries(newObjectToPost).map(([key, value]) => {
        formData.append(key, String(value));
      });
      
      formData.append("file", selectedFile);
      
      VersionDescriptionArray.map(desc => {
        formData.append("VersionDescriptionArray", desc);
      });
      console.log("🚀 ~ handleMajSpiderSave ~ VersionDescriptionArray:", VersionDescriptionArray)

      console.log("🚀 ~ handleMajSpiderSave ~ formData---------------------:", formData)
      
      // Envoi de la requête
      const res = await axios.post(`${SITEWEB_SERVER_BASE_URL}/ajouterspidernewversion`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      console.log("🚀 ~ handleMajSpiderSave ~ SITEWEB_SERVER_BASE_URL:", SITEWEB_SERVER_BASE_URL)
  
      console.log("✅ Résultat de l'envoi******************** :", res.data);
  
      // Traitement de la réponse
      if (res.data.status === 1) {
        const formatedData = {
          ...res.data.data,
          VersionDescriptionArray: JSON.parse(res.data.data.VersionDescriptionArray)
        };
        dispatch(addMajSpider(formatedData));
        successNotify("Action effectuée avec succès");
      } else {
        errorNotify("Erreur lors de l'enregistrement");
      }
  
    } catch (error) {
      console.log("❌ Erreur lors de l'enregistrement :", error);
      errorNotify("Une erreur est survenue");
    } finally {
      setAddLoading(false);
    }
  };
  

  return (
    <PostDialog
      onClose={onClose}
      open={open}
      dialogContent={
        <Add
          majSpiderState={majSpiderState}
          setMajSpiderState={setMajSpiderState}
          selectedFile={selectedFile}
          fonctionnaliteListe={fonctionnaliteListe}
          setFonctionnaliteListe={setFonctionnaliteListe}
          setSelectedFile={setSelectedFile}
        />}
      actionFunc={handleMajSpiderSave}
      title="Mise à jour spider"
      addLoading={addLoading}
      handleOpenDialog={handleOpenDialog}
    />

  );
};
export default DialogAdd;



